export default __webpack_public_path__ + "static/media/tramy_news_2.91e85ae8.svg";